var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feather-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"text-warning ml-2 cursor-not-allowed",attrs:{"icon":"AlertTriangleIcon","size":"20"}})}
var staticRenderFns = []

export { render, staticRenderFns }